module.exports = __webpack_public_path__ + "img/spotify.fc0a319a.svg";